import api from "src/apis/api"

export async function fetchPortalBookings() {
  const { data } = await api.get("/api/v1/portal/bookings")
  return data.bookings || []
}

export async function fetchPortalBooking(id) {
  const { data } = await api.get(`/api/v1/portal/bookings/${id}`)
  return data.booking
}
